import { Field, Input } from "@ngt/forms-core";
import { FC, useMemo } from 'react';
import { CustomFormField, SpeciesForm } from '../../../../../api/dtos/dtos';
import useGetAllRegions from '../../../../../hooks/data/useGetAllRegions';
import InputAutocomplete, { IAutocompleteItem } from "../../InputAutoComplete";
import TextFieldControlLabel from "../../labels/TextFieldControlLabel";
import FieldErrors from "../../utils/FieldErrors";

interface ICustomRegionsDropdownProps {
    field: CustomFormField;
    form: SpeciesForm;
}

const CustomRegionsDropdown: FC<ICustomRegionsDropdownProps> = ({form, field}) => {

    // Fetch options data from database
    const { data: regions, loading: regionsLoading} = useGetAllRegions({ excludeStates: false }, { revalidateOnFocus: false });

    // Format and order options data for dropdown 
    const options = useMemo(() => {
        if (!regions || regionsLoading){
            return [];
        }

        return regions?.sort((a, b) => a.name.localeCompare(b.name))?.map(x => {
            return {
                id: x.regionId,
                value: x.name
            } as IAutocompleteItem<number>;
        });
    }, [regions]);

    return (
        <TextFieldControlLabel 
            field={field}
            control={
                <Field propertyPath={`${form.name}.${field?.meta?.targetName}`}>
                    <FieldErrors />
                    <Input 
                        fullWidth
                        size="small"
                        component={InputAutocomplete}
                        options={options ?? []}
                    />
                </Field>
            }
        />
    );
};

export default CustomRegionsDropdown;